import { useEffect, useRef } from 'react'

/**
 * Подгружает следующую страницу, когда маркер в конце списка попадает во вьюпорт.
 *
 * `enabled` выключается на время запроса и когда данные кончились: наблюдатель
 * пересоздаётся после каждой загрузки, поэтому длинный экран догружается сам,
 * пока маркер остаётся видимым.
 */
export const useInfiniteScroll = (onLoadMore: () => void, enabled: boolean) => {
    const sentinelRef = useRef<HTMLDivElement | null>(null)
    const loadMoreRef = useRef(onLoadMore)
    loadMoreRef.current = onLoadMore

    useEffect(() => {
        const node = sentinelRef.current
        if (!node || !enabled) return

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) loadMoreRef.current()
            },
            { rootMargin: '200px' },
        )

        observer.observe(node)
        return () => observer.disconnect()
    }, [enabled])

    return sentinelRef
}
